<div class="logo">
  <img src="/assets/img/SABS_logo.png" class="simple-text logo-normal custom-sidebar-logo whole-logo"
    style="padding: 5px 15px;" [ngClass]="logoWidth < 240 && bodyClass=='sidebar-mini'?'sidebar-collapsed':''">
  <img src="/assets/img/SABS_single_logo.png" class="simple-text logo-normal custom-sidebar-logo single-logo"
    style="padding: 5px 15px;" [ngClass]="( logoWidth < 240 ) && bodyClass=='sidebar-mini'?'sidebar-collapsed':''">

</div>

<div class="sidebar-wrapper">


  <div *ngIf="isMobileMenu()">

    <ul class="nav navbar-nav nav-mobile-menu">
      <!-- <li class="nav-item dropdown">
        <a class="nav-link" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <i class="material-icons">notifications</i>
          <span class="notification">5</span>
          <p>
            <span class="d-lg-none d-md-block">Some Actions</span>
          </p>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item" href="#">Mike John responded to your email</a>
          <a class="dropdown-item" href="#">You have 5 new tasks</a>
          <a class="dropdown-item" href="#">You're now friend with Andrew</a>
          <a class="dropdown-item" href="#">Another Notification</a>
          <a class="dropdown-item" href="#">Another One</a>
        </div>
      </li> -->
      <li class="nav-item no-hover-effect">
        <a class="nav-link">
          <p>
            <span class="d-lg-none d-md-block" style="color:#000;">{{username}} | {{userAccountType?.nameEn}}</span>
          </p>
        </a>
      </li>
      <li class=" nav-item">
        <a class="nav-link" routerLink="profile-setting">
          <i class="material-icons">person</i>
          <p>
            <span class="d-lg-none d-md-block">Profile Settings</span>
          </p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="logout()">
          <i class="material-icons">logout</i>
          <p>
            <span class="d-lg-none d-md-block">Logout</span>
          </p>
        </a>
      </li>

    </ul>
    <div class="user" style="padding: 0; margin: 0;"></div>
  </div>
  <ul class="nav">
    <li routerLinkActive="active" *ngFor="let menuitem of menuItems" class="nav-item">
      <!--If is a single link-->
      <a [routerLink]="[menuitem.path]" *ngIf="menuitem.type === 'link'" class="nav-link">
        <i class="material-icons">{{menuitem.icontype}}</i>
        <p>{{menuitem.title}}</p>
      </a>
      <!--If it have a submenu-->
      <a data-toggle="collapse" href="#{{menuitem.collapse}}" id="{{menuitem.collapse}}-p"
        *ngIf="menuitem.type === 'sub'" (click)="updatePS();expandOrCollapseMenu(menuitem.collapse)" class="nav-link">
        <i class="material-icons">{{menuitem.icontype}}</i>
        <p>{{menuitem.title}}<b class="caret"></b></p>
      </a>

      <!--Display the submenu items-->
      <div id="{{menuitem.collapse}}" class="collapse" *ngIf="menuitem.type === 'sub'">
        <ul class="nav">
          <li routerLinkActive="active" *ngFor="let childitem of menuitem.children" class="nav-item">
            <a [routerLink]="[menuitem.path, childitem.path]" class="nav-link">
              <i class="material-icons custom-icon"
                [ngClass]="logoWidth==80?'sidebar-collapsed':''">{{isActive(childitem)?'radio_button_checked':'radio_button_unchecked'}}</i>
              <span class="sidebar-normal">{{childitem.title}}</span>
            </a>
          </li>
        </ul>
      </div>
    </li>

  </ul>

</div>